// extracted by mini-css-extract-plugin
export default {"presetWrapper":"PresetsOption_presetWrapper__2dH2l"};